import { State } from '../reducers/rootReducer'
import { FailedRequestsState } from '../reducers/failedRequestsReducer'

const failedRequestsSelector = (state: State): FailedRequestsState => state.failedRequests

export default failedRequestsSelector
